// extracted by mini-css-extract-plugin
export var deleteIcon = "_qf-5";
export var deleteOption = "_qf-3";
export var divider = "_qf-2";
export var downloadIcon = "_qf-4";
export var drawer = "_qf-0";
export var drawerFooter = "_qf-6";
export var drawerOpen = "_qf-1";
export var highlighted = "_qf-7";
export var lighterHighlight = "_qf-8";